export default __webpack_public_path__ + "static/media/basic-download.6c866581.svg";